import React from 'react';

export const CategoryRevenueBenchmarkContext = React.createContext({});
